import styled from "@emotion/styled";

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StackedContainer = styled(CenteredContainer)`
  display: flex;
  flex-direction: column;
  justify-content: start;
`;
